import React from 'react';
import Line from 'components/Line';
import Layout1x1 from 'components/Layout1x1';
import DoubleHeader from 'components/DoubleHeader';
import NextSteps from 'components/NextSteps';
import SalesCalloutHTO from 'components/SalesCalloutHTO';
import SalesCalloutSwatches from 'components/SalesCalloutSwatches';
import { withPageStaticProps } from 'utils/header';

class SmsPrivacyPolicy extends React.Component {
  render() {
    return (
      <>
        <Layout1x1 className="m-section-hero">
          <DoubleHeader hero smallTitle={<h2>Menguin</h2>} largeTitle={<h1>SMS/MMS Mobile Messaging Marketing Program</h1>} />

          <Line />

          <p>
            <strong>Last updated: 12/13/2021</strong>
          </p>

          <p>
            We respect your privacy. The Menguin SMS/MMS Mobile Messaging Marketing Program (the Program) includes and is limited to text
            and media sent to or from the short code 664846. We will only use information you provide through the Program to transmit your
            mobile messages and respond to you, if necessary. This includes, but is not limited to, sharing information with platform
            providers, phone companies, and other vendors who assist us in the delivery of mobile messages. We do not sell, rent, loan,
            trade, lease, or otherwise transfer for profit any phone numbers or other personally identifiable customer information collected
            through the Program to any third party for the purposes of that third party’s marketing initiatives. Nonetheless, we reserve the
            right at all times to disclose any information as necessary to satisfy any law, regulation or governmental request, to avoid
            liability, or to protect Our rights or property. When you complete forms online or otherwise provide Us information in
            connection with the Program, you agree to provide accurate, complete, and true information. You agree not to use a false or
            misleading name or a name that you are not authorized to use. If, in Our sole discretion, We believe that any such information
            is untrue, inaccurate, or incomplete, or you have opted into the Program for an ulterior purpose, We may refuse you access to
            the Program and pursue any appropriate legal remedies.
          </p>

          <p>
            California Civil Code Section 1798.83 permits Users of the Program that are California residents to request certain information
            regarding our disclosure of the information you provide through the Program to third parties for their direct marketing
            purposes. To make such a request, please contact us at the following address:
          </p>

          <address>
            Menguin <br />
            11000 Electron Drive <br />
            Louisville, KY 40299 <br />
          </address>
          <a className="text-anchor" href="mailto:ccpa@menguin.com">
            ccpa@menguin.com
          </a>

          <p>
            This Privacy Policy is strictly limited to the Program and has no effect on any other privacy policy(ies) that may govern the
            relationship between you and Us in other contexts.
          </p>
        </Layout1x1>
        <NextSteps
          ctaPageName="privacy"
          salesCallout1={<SalesCalloutHTO ctaPageName="privacy" />}
          salesCallout2={<SalesCalloutSwatches ctaPageName="privacy" />}
        />
      </>
    );
  }
}

export const getStaticProps = withPageStaticProps();

export default SmsPrivacyPolicy;
